export default "__VITE_ASSET__CLR$OQ3V__"